<button
  class="btn btn-close d-flex align-items-center justify-content-center bg-secsel rounded-circle"
  (click)="activeModal.close()"
>
  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9971 2.00195L2.00381 11.9953" stroke="black" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M12 12.0018L1.99832 1.99805" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>
